import styled, { css } from "styled-components";

const sizes = {
    small: css`
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
    text-align: center;
  `,
    medium: css`
    font-size: 1.2rem;
    padding: 1.2rem 1.6rem;
  `,
    large: css`
    font-size: 1.4rem;
    padding: 1.2rem 2.4rem;
  `,
};

const variations = {
    primary: css`
        color: #000000; // Text color
        background-color: #f9cbdf !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        border-radius: 1000px;
        border: 1px solid #c65bbc;
        &:hover {
            background-color: #535bf2;
        }
    `,
    
    secondary: css`
        color: #7e7e7e;
        background: #535bf2;
        border: 1px solid #213547;
        &:hover {
            background-color: #535bf2;
        }
    `,
    
    danger: css`
    color: var(--color-red-100);
    background-color: var(--color-red-700);
    &:hover {
      background-color: var(--color-red-800);
    }
  `,

    calendar_default: css`
        color: #cc4c92;
        border: 1px solid #213547;
        border-radius: 1000px;

        &:hover {
            background-color: #535bf2;
        }
    `,
};

const ButtonBase = styled.button`
    border: none;
    border-radius: 2px;
    box-shadow: var(--shadow-sm);
    ${(props) => sizes[props.size]}
    ${(props) => variations[props.variation]}
`;

const Button = ({ href, ...props }) => {
    if (href) return <ButtonBase as="a" href={href} {...props} />;
    return <ButtonBase {...props} />;
};

export default Button;


Button.defaultProps = {
    variation: "primary",
    size: "medium",
};

